@use '@/scss/underscore' as _;

.icon {
  flex-shrink: 0;
}
